import React, { Component } from 'react'

import ReactHighmaps from 'react-highcharts/ReactHighmaps.src'
import LayerHeaderMapConfig from './LayerHeaderMapConfig'
import LayerHeaderMapAdapter from './LayerHeaderMapAdapter'

import ObjectTools from 'utils/objects/objectTools'

import Loading from 'components/Loading'
import Error from 'components/Error'

class LayerHeaderMap extends Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: true,
      error: false
    }

    this.mapRef = React.createRef()
  }

  componentDidMount() {
    if (this.props.regionsData && this.props.selectedRegionId) {
      this.getMap()
    }
  }

  componentDidUpdate(prevProps) {
    if (
      (prevProps.regionsData === undefined && this.props.regionsData !== undefined) ||
			(prevProps.selectedRegionId === undefined && this.props.selectedRegionId !== undefined)
    ) {
      this.getMap()
    } else if (this.props.regionsData && this.props.selectedRegionId) {
      if (prevProps.selectedRegionId !== this.props.selectedRegionId) {
        this.setState({ loading: true, error: false }, this.getMap)
      }
    }
  }

  getMap() {
    if (this.state.loading) {
      let chartConfig = LayerHeaderMapConfig.generalConfig
      let series = LayerHeaderMapAdapter.formatMapSeries({ regionsData: this.props.regionsData, selectedRegionId: this.props.selectedRegionId })
      chartConfig.series = series
      this.setState({ chartConfig, loading: false, error: false })
    }
  }

  renderIfAllOK() {
    if (this.state.error) {
      return <Error />
    } else if (this.state.loading) {
      return <Loading />
    } else {
      let renderingComponent
      let width = document.querySelector('.ork-region-changing').clientWidth - 30
      let domProps = ObjectTools.copyObject(LayerHeaderMapConfig.domProps)
      domProps.style.height = `${width}px`

      renderingComponent = <ReactHighmaps ref={this.mapRef} config={this.state.chartConfig} domProps={domProps} />
      return renderingComponent
    }
  }

  render() {
    return <React.Fragment>{this.renderIfAllOK()}</React.Fragment>
  }
}

export default LayerHeaderMap



// WEBPACK FOOTER //
// ./src/modules/Charts/Map/LayerHeaderMap/LayerHeaderMap.jsx